const resolveApiBaseUrl = (): string => {
  const configuredBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
  const hasConfiguredBaseUrl = Boolean(configuredBaseUrl);
  const hasAbsoluteHttpConfiguredBaseUrl = Boolean(configuredBaseUrl && /^https?:\/\//i.test(configuredBaseUrl));
  const hasRelativeConfiguredBaseUrl = Boolean(configuredBaseUrl && configuredBaseUrl.startsWith('/'));
  const hasWindowsPathLikeConfiguredBaseUrl = Boolean(
    configuredBaseUrl &&
      (/^[a-z]:[\\/]/i.test(configuredBaseUrl) || configuredBaseUrl.startsWith('\\\\'))
  );

  // Defensive fallback for shell path-conversion issues (e.g. '/api' -> 'C:/...').
  if (hasConfiguredBaseUrl && (hasWindowsPathLikeConfiguredBaseUrl || (!hasAbsoluteHttpConfiguredBaseUrl && !hasRelativeConfiguredBaseUrl))) {
    return '/api';
  }

  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();
    const isStagingHost = host.includes('staging');

    // Staging must always use the same-origin API proxy to avoid accidental cross-environment routing.
    if (isStagingHost && hasAbsoluteHttpConfiguredBaseUrl) {
      return '/api';
    }
  }

  return configuredBaseUrl || '/api';
};

// Environment configuration
export const API_CONFIG = {
  BASE_URL: resolveApiBaseUrl(),
  BUYER_GEO_URL: process.env.REACT_APP_BUYER_GEO_URL || 'https://api.country.is/?fields=subdivision',
  TELEGRAM_FEATURE_ENABLED: process.env.REACT_APP_ENABLE_TELEGRAM_FEATURE === 'true',
  AUTH_LOGIN_ENDPOINT: process.env.REACT_APP_AUTH_LOGIN_ENDPOINT || '/Auth/Login',
  AUTH_REGISTER_ENDPOINT: process.env.REACT_APP_AUTH_REGISTER_ENDPOINT || '/Auth',
  AUTH_REFRESH_ENDPOINT: process.env.REACT_APP_AUTH_REFRESH_ENDPOINT || '/Auth/RefreshToken',
  AUTH_CHANGE_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_CHANGE_PASSWORD_ENDPOINT || '/Auth/change-password',
  AUTH_FORGOT_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_FORGOT_PASSWORD_ENDPOINT || '/Auth/forgot-password',
  AUTH_RESET_PASSWORD_ENDPOINT: process.env.REACT_APP_AUTH_RESET_PASSWORD_ENDPOINT || '/Auth/reset-password',
  USERS_ENDPOINT: process.env.REACT_APP_USERS_ENDPOINT || '/Users',
  TRANSACTIONS_ENDPOINT: process.env.REACT_APP_TRANSACTIONS_ENDPOINT || '/Transactions',
  EXCHANGE_API_KEY: process.env.REACT_APP_EXCHANGE_API_KEY || '',
};

export const API_ENDPOINTS = {
  LOGIN: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_LOGIN_ENDPOINT}`,
  REGISTER: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_REGISTER_ENDPOINT}`,
  REFRESH_TOKEN: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_REFRESH_ENDPOINT}`,
  AUTH_CHANGE_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_CHANGE_PASSWORD_ENDPOINT}`,
  AUTH_FORGOT_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_FORGOT_PASSWORD_ENDPOINT}`,
  AUTH_RESET_PASSWORD: `${API_CONFIG.BASE_URL}${API_CONFIG.AUTH_RESET_PASSWORD_ENDPOINT}`,
  USERS: `${API_CONFIG.BASE_URL}${API_CONFIG.USERS_ENDPOINT}`,
  TRANSACTIONS: `${API_CONFIG.BASE_URL}${API_CONFIG.TRANSACTIONS_ENDPOINT}`,
  SETTINGS_FEES: `${API_CONFIG.BASE_URL}/settings/fees`,
  SETTINGS_FEES_PLATFORM_UNLOCK: `${API_CONFIG.BASE_URL}/settings/fees/platform-processing/unlock`,
  SETTINGS_FEES_PLATFORM_UPDATE: `${API_CONFIG.BASE_URL}/settings/fees/platform-processing`,
};
